import CONFIG from '../../config';

const actions = {
  webflow(context, params) {
    context.commit('ADD_LOG', { request: 'webflow' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('webflow'), params, {
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'webflow' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'webflow' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  webflowMembershipDetails(context, params) {
    context.commit('ADD_LOG', { request: 'webflowMembershipDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('webflowMembershipDetails'), params, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'webflowMembershipDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'webflowMembershipDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  webflowShortReferral(context, params) {
    context.commit('ADD_LOG', { request: 'webflowShortReferral' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('webflowShortReferral'), params, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'webflowShortReferral' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'webflowShortReferral' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  v2WebflowShortReferral(context, params) {
    context.commit('ADD_LOG', { request: 'v2WebflowShortReferral' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('v2WebflowShortReferral'), params.patchParams, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'v2WebflowShortReferral' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'v2WebflowShortReferral' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  v3WebflowShortReferral(context, params) {
    context.commit('ADD_LOG', { request: 'v3WebflowShortReferral' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('v3WebflowShortReferral'), params.patchParams, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'v3WebflowShortReferral' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'v3WebflowShortReferral' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  webflowApproval(context) {
    context.commit('ADD_LOG', { request: 'webflowApproval' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('webflowApproval'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'webflowApproval' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'webflowApproval' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  webflowCustomerDetails(context, params) {
    context.commit('ADD_LOG', { request: 'webflowCustomerDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('webflowCustomerDetails'), params, {
          headers: {
            Authorization: localStorage.getItem('token'),
            'x-phone-number': localStorage.getItem('phone')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'webflowCustomerDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'webflowCustomerDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
};
export default actions;
